import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { StateConsumer } from './State';

const Wrapper = styled.button`
  padding: 1em 2em;
  background: transparent;
  border: 0;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  cursor: pointer;

  @media screen and (max-width: 1024px) and (max-height: 900px) {
    padding: 0.5em;
    z-index: 1000;
    ${props => {
      if (props.showClose) {
        return css`
          top: 0;
          left: auto;
          right: 0;
          transform: translateY(0%);
        `;
      }

      return css`
        top: ${props.inHome ? 72 : 54}px;
        left: 50%;
        transform: translate(-50%, 0%);
      `;
    }};
  }

  @media screen and (max-height: 420px) {
    top: 0;
    left: auto;
    right: 0;
    transform: translateY(0%);
  }
`;

const Burger = styled.div`
  position: relative;
  width: 66px;
  height: 33px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  justify-content: space-between;
  @media screen and (max-width: 1024px) and (max-height: 900px) {
    width: 40px;
    height: 20px;
  }
`;

const LineTop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #cccccc;
  transform-origin: center center;
  ${props =>
    props.showClose &&
    css`
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
    `};
`;
const LineBottom = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #cccccc;
  transform-origin: center center;
  ${props =>
    props.showClose &&
    css`
      bottom: 50%;
      transform: translateY(-50%) rotate(-45deg);
    `};
`;

const LineCenter = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 1px;
  background-color: #484748;
  ${props =>
    props.showClose &&
    css`
      opacity: 0;
    `};
`;

const MenuButton = ({ staticButton, inHome }) => (
  <StateConsumer>
    {context => (
      <Wrapper
        type="button"
        onClick={context.actions.toggleMenu}
        showClose={context.state.menuOpen}
        static={staticButton}
        inHome={inHome}
      >
        <Burger>
          <LineTop showClose={context.state.menuOpen} />
          {<LineCenter showClose={context.state.menuOpen} />}
          <LineBottom showClose={context.state.menuOpen} />
        </Burger>
      </Wrapper>
    )}
  </StateConsumer>
);

MenuButton.propTypes = {
  staticButton: PropTypes.bool,
  inHome: PropTypes.bool,
};

MenuButton.defaultProps = {
  staticButton: false,
  inHome: false,
};

export default MenuButton;
